import React from "react";

export default function CompanyOverview({ register, errors }) {
  const fieldName = "companyoverview";

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Brief overview of your company
      </label>
      <textarea
        id={fieldName}
        className="wdc-field"
        rows="4"
        placeholder="Tell us what your company does…"
        {...register(fieldName, { required: true })}
      />
      {errors[fieldName] && (
        <span className="wdc-error">This field is required</span>
      )}
    </div>
  );
}
